// The app coming back to the front, as a bus any screen can hear.
//
// iOS freezes the WebView the moment the phone locks or another app is
// opened. `setInterval` on the train card does not fire. `visibilitychange`
// often never says "hidden" in a Capacitor WebView, so the page thinks it is
// still polling. Home already listens to Capacitor `appStateChange`; the
// train and journey pages did not, which is why they sat on last-seen times
// until somebody happened to open them again.
//
// THIS IS NOT BACKGROUND EXECUTION. Nothing here runs while the app is in a
// pocket. It is the first moment iOS lets JavaScript run again.

const listeners = new Set();

/** Subscribe. Returns an unsubscribe function. */
export function onForeground(fn) {
  if (typeof fn !== 'function') return () => {};
  listeners.add(fn);
  return () => { listeners.delete(fn); };
}

/** Tell every open screen the phone is in front of someone again. */
export function notifyForeground() {
  for (const fn of [...listeners]) {
    try { fn(); } catch { /* one page must not silence the others */ }
  }
}

// And the other way: the app going to the background. The last moment a
// screen can note what was on it before iOS freezes the WebView.
const leaving = new Set();

/** Subscribe to the app going to the background. Returns an unsubscribe. */
export function onBackground(fn) {
  if (typeof fn !== 'function') return () => {};
  leaving.add(fn);
  return () => { leaving.delete(fn); };
}

/** Tell every open screen the app is leaving the front. */
export function notifyBackground() {
  for (const fn of [...leaving]) {
    try { fn(); } catch { /* one page must not silence the others */ }
  }
}

/** Tests only. */
export function resetForeground() {
  listeners.clear();
  leaving.clear();
}
